const vowels = {
  a: "A",
  e: "E",
  i: "I",
  o: "O",
  u: "U"
};
const indefiniteArticleOf = (articles, word) => {
  const firstChar = word.charAt(0).toLocaleLowerCase("en-US");
  return firstChar in vowels ? `${articles[1]} ${word}` : `${articles[0]} ${word}`;
};

export { indefiniteArticleOf };
//# sourceMappingURL=grammar.esm.js.map
